import { memo, useMemo } from 'react'
import { CreatorCardMini } from '@winnin/winnin_ui.components.creator-card-mini'

import RefreshCreatorImageButton from 'components/RefreshCreatorImageButton'
import { useSelectedItemsList } from 'contexts/SelectedItemsListProvider'
import { useTranslate } from 'lib/tolgee'
import { UserStore } from 'stores'
import { TOLGEE_GLOBALS } from 'utils'
import './index.scss'

function CreatorCardMiniWithTolgee({ id, groupId, isActionsBlocked, disableRefresh, ...props }) {
  const t = useTranslate()
  const { selectedItemsBar, addItem, removeItem } = useSelectedItemsList()
  const { provider, title, thumbnail } = props

  const tolgeeTexts = useMemo(() => {
    return {
      tooltipCheckbox: t(TOLGEE_GLOBALS.selectThisCreator),
      isTrendingTooltip: t(TOLGEE_GLOBALS.isTrendingCreatorTooltip),
      brandText: t(TOLGEE_GLOBALS.brand),
      followersText: t(TOLGEE_GLOBALS.followers),
      subsText: t(TOLGEE_GLOBALS.subscribers),
      brandGroupText: t(TOLGEE_GLOBALS.brandGroup),
      tooltipBrandGroup: t(TOLGEE_GLOBALS.tooltipBrandGroup),
    }
  }, [t])

  function handleCreatorCheckbox(e) {
    e.preventDefault()
    e.stopPropagation()

    const isItemSelected = selectedItemsBar.find(item => item.id === id)
    if (isItemSelected) {
      removeItem(isItemSelected)
      return
    }
    addItem({ id, name: title, type: 'creators', provider, thumbnail, groupId })
  }
  const checkIsActive = selectedItemsBar?.some(check => check.id === id)

  return (
    <CreatorCardMini
      tolgeeTexts={tolgeeTexts}
      data-dd-action-name="CreatorCardMini"
      isCheckboxActive={checkIsActive}
      onCheckboxClick={e => handleCreatorCheckbox(e)}
      hideCheckbox={UserStore?.getRole === 'viewer' || isActionsBlocked}
      className="CreatorCardMiniWithTolgee"
      thumbnailFallback={disableRefresh ? null : <RefreshCreatorImageButton id={id} provider={provider} />}
      {...props}
    />
  )
}

export default memo(CreatorCardMiniWithTolgee)
